module.exports = __webpack_public_path__ + "static/media/logo_login.6bcfad89.png";